import { render } from "./NotificationModal.vue?vue&type=template&id=239d62ff&scoped=true"
import script from "./NotificationModal.js?vue&type=script&lang=js"
export * from "./NotificationModal.js?vue&type=script&lang=js"

import "./NotificationModal.vue?vue&type=style&index=0&id=239d62ff&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239d62ff"]])

export default __exports__